<template>
    <div class="container">
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error}}</div>

        </div>

        <b-form @submit="onSubmit">
            <b-form-group
                id="input-password"
                label="Password"
                label-for="password"
            >
                <b-form-input
                    id="password"
                    v-model="item.password"
                    type="password"
                    placeholder="password"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-check-password"
                label="Check-password"
                label-for="check-password"
            >
                <b-form-input
                    id="check-password"
                    v-model="item.password_confirmation"
                    type="password"
                    placeholder="Check password"
                ></b-form-input>
            </b-form-group>

            <div class="buttons">
                <b-button type="submit">Update</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
    const swal = require('sweetalert2');
    export default {
        data() {
            return {
                item: {},
                errors: []
            }
        },

        methods: {
            checkForm: function (e) {
                e.preventDefault();
                this.errors = [];
                if (!this.item.password) this.errors.push("Пароль обязателен.");
                if (this.item.password && this.item.password.length <= 5) this.errors.push("Минимальная длина пароля 6 символов.");
                if (!/\d/.test(this.item.password)) this.errors.push("Содержать минимум одну цифру.");
                if (!/[A-Z]/.test(this.item.password)) this.errors.push("Содержать минимум 1 заглавную букву.");
                if (this.item.password !== this.item.password_confirmation) this.errors.push("Пароли не совпадают.");
            },

            onSubmit(e) {
                this.checkForm(e)
                if (this.errors.length === 0) {
                    this.axios
                        .put(this.axios.defaults.baseURL + 'change-password/' + this.$route.params.id, this.item)
                        .then(response => {
                            if (response.data.message === 'success') {
                                swal.fire({
                                    icon: 'success',
                                    title: 'Пароль успешно обновлен',
                                    showConfirmButton: true,
                                    onClose: () => {
                                        this.$router.go(-1)
                                    }
                                });
                            } else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/auth/change-password.vue